module.exports = __webpack_public_path__ + "assets/img/btn2.982f1745.png";